<template>
  <svg viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">
    <polyline fill="none" points="144 168 184 208 224 168" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/>
    <line fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="16" x1="184" x2="184" y1="112" y2="208"/>
    <line stroke-linecap="round" stroke-linejoin="round" stroke-width="16" x1="48" x2="120" y1="128" y2="128"/>
    <line stroke-linecap="round" stroke-linejoin="round" stroke-width="16" x1="48" x2="184" y1="64" y2="64"/>
    <line stroke-linecap="round" stroke-linejoin="round" stroke-width="16" x1="48" x2="104" y1="192" y2="192"/>
  </svg>
</template>
